import { createFileRoute } from '@tanstack/react-router';
import { assertPublicToolsEnabled } from '@/lib/public-tools-feature';
import {
  getKeywordToolPage,
  KeywordToolSeoPage,
} from '@/components/astro/new-design-25/SEO/keyword-tool-pages';
import { normalizeCanonicalUrl } from '@/seo/canonical';
import { seo } from '@/seo/seo';

const page = getKeywordToolPage('english-text-to-speech');
if (!page) throw new Error('Missing keyword SEO page: english-text-to-speech');

export const Route = createFileRoute('/_marketing/_seo/english-text-to-speech')(
  {
    beforeLoad: assertPublicToolsEnabled,
    head: () => ({
      meta: [
        ...seo({
          title: page.metaTitle,
          description: page.metaDescription,
        }),
      ],
      links: [
        {
          rel: 'canonical',
          href: normalizeCanonicalUrl('/english-text-to-speech'),
        },
      ],
    }),
    component: () => <KeywordToolSeoPage page={page} />,
  },
);
